// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./imgs/img-loading.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Loading-module__root--TBaQQ {
  position: relative;
  display: inline-block;
  width: 42px;
  height: 42px;
  flex-shrink: 0;
  border-radius: 21px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center no-repeat;
  animation: Loading-module__spin--coan7 800ms linear infinite;
}

@keyframes Loading-module__spin--coan7 {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .Loading-module__root--TBaQQ {
    animation-duration: 1600ms;
  }
}`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Loading/Loading.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,2EAAiE;EACjE,4DAAqC;AACvC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".root {\n  position: relative;\n  display: inline-block;\n  width: 42px;\n  height: 42px;\n  flex-shrink: 0;\n  border-radius: 21px;\n  background: url('./imgs/img-loading.svg') center center no-repeat;\n  animation: spin 800ms linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .root {\n    animation-duration: 1600ms;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Loading-module__root--TBaQQ`,
	"spin": `Loading-module__spin--coan7`
};
export default ___CSS_LOADER_EXPORT___;
